import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-loading-progress-bar',
    templateUrl: './loading-progress-bar.component.html',
    styleUrls: ['./loading-progress-bar.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingProgressBarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
